<template>
    <form
        ref="templateForm"
        @submit.prevent="submit"
        :action="url"
        method="post"
        class="card border-2 border-sky-500 flex flex-col gap-4"
    >
        <h2 class="text-2xl text-gray-700 font-semibold">
            {{ job ? 'Update' : 'Create' }} Your Job Post
        </h2>

        <input v-if="job" type="hidden" name="_method" value="PUT">

        <text-input
            name="title"
            label="Title"
            placeholder="SQL Developer"
            v-model="form.title"
            :error="form.errors.title"
        />

        <text-input
            name="company"
            label="Company"
            placeholder="National Goliath Bank"
            v-model="form.company"
            :error="form.errors.company"
        />

        <text-input
            name="location"
            label="Location"
            placeholder="NY, NY - Remote"
            v-model="form.location"
            :error="form.errors.location"
        />

        <text-input
            name="tags"
            label="Tags"
            placeholder="Python,C++,MySQL,SQL Server,R"
            v-model="form.tags"
            :error="form.errors.tags"
            help="Up to 5 tags that describe the role or requirements."
        />

        <text-input
            name="link"
            label="Link"
            placeholder="https://yourcompany.com/careers/awesome-sql-job"
            v-model="form.link"
            :error="form.errors.link"
        />

        <file-input
            name="logo"
            label="Logo"
            v-model="form.logo"
            :errors="form.errors.logo"
            help="Logos will be resized to 200x200. Upload a 1x1 photo for best results."
        />

        <loading-button
            class="btn btn-green md:self-end"
            :loading="form.processing"
        >
            {{ job ? 'Update' : 'Create' }} Post
        </loading-button>
    </form>
</template>

<script setup>
import useForm from '@/functions/useForm'
import { ref } from 'vue'

const props = defineProps({
    url: {
        type: String,
        required: true,
    },
    job: {
        type: Object
    }
})
const templateForm = ref(null)

const form = useForm({
    title: props.job?.title ??'',
    company: props.job?.company ??'',
    location: props.job?.location ??'',
    tags: props.job?.tags ??'',
    link: props.job?.link ??'',
})

const submit = () => {
    form.transform(() => new FormData(templateForm.value)).post(props.url)
}
</script>
